var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 27.086 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Icon ionic-ios-warning",
    d: "M11.777 1.035L.247 22.077A1.979 1.979 0 002.012 25h23.066a1.983 1.983 0 001.764-2.923L15.306 1.035a2.021 2.021 0 00-3.529 0zm2.91 8.73l-.234 7.943H12.63l-.234-7.943zm-1.145 12.266a1.2 1.2 0 111.243-1.2 1.209 1.209 0 01-1.243 1.2z",
    fill: "#f60"
  })));
}

export default __webpack_public_path__ + "2677504a071ba4d433c65037974d4355.svg";
export { SvgWarning as ReactComponent };